import React from 'react';
import MenuItem from '../menuitem/menuitem.component';
import './menu.styles.scss';
import { language } from '../../../utils/lang';

const menuItems = [
  {
    pageTitle: "UZMAN BUL",
    pageLink: "uzman-bul",
    clickable: true,
    alias:"findExpert",
    routeAlias:"findExpert",
    subItems:[]
  },
  {
    pageTitle:"HAKKIMIZDA",
    pageLink:"hakkimizda",
    clickable: true,
    alias:"aboutUs",
    routeAlias:"aboutUs",
    subItems:[]
  },
  {
    pageTitle:"BLOG",
    pageLink:"blog",
    clickable: true,
    alias:"articles",
    routeAlias:"blog",
    subItems:[]
  },
  {
    pageTitle:"ÇALIŞMALAR",
    pageLink:"blog",
    clickable: false,
    alias:"calismalar",
    routeAlias:"calismalar",
    subItems:[
      {
        pageTitle: "EĞİTİMLER",
        pageLink: "egitimler",
        clickable:true,
        alias:"egitimler",
        routeAlias:"educations",
        subItems:[]
      },
      {
        pageTitle: "TOPLANTILAR",
        pageLink: "toplantilar",
        clickable:true,
        alias:"toplantilar",
        routeAlias:"meetings",
        subItems:[]
      },
      {
        pageTitle: "FARKINDALIK ÇALIŞMALARI",
        pageLink: "farkindalik-calismalari",
        clickable:true,
        alias:"farkindalikCalismalari",
        routeAlias:"awarenessCampaigns",
        subItems:[]
      },
      {
        pageTitle: "MENTORLUK",
        pageLink: "mentorluk",
        clickable:true,
        alias:"mentorluk",
        routeAlias:"mentoring",
        subItems:[]
      }            
    ]
  },
  {
    pageTitle:"İLETİŞİM",
    pageLink:"iletisim",
    clickable: true,
    alias:"contactUs",
    routeAlias:"contactUs",
    subItems:[]
  }  
]; 
const Menu = (props) => {
  const menuList = menuItems.map((e, i) => 
    <MenuItem pageTitle={e.pageTitle} pageLink={e.pageLink} clickable={e.clickable} alias={e.alias} routeAlias={e.routeAlias} subItems={e.subItems}  active={props.activeMenu !== undefined ? true : false} key={`menuitem_${i}`} />
  )  
  
  return(
    <ul className="bottomMenu">
      {menuList}
    </ul>
  );
}

export default Menu;